module.exports = __webpack_public_path__ + "media/components/lesson2/common/statics/connectBlock-1d1d50904557b9fe430b610aed7e5539.gif";